type ClientConfig = {
  hideProductCount?: boolean
  useClientShippingId?: boolean
  showReturningProducts?: boolean
}

const FMJ: ClientConfig = {
  hideProductCount: true,
}

const HANJIN: ClientConfig = {
  useClientShippingId: true,
}

const CJ: ClientConfig = {
  useClientShippingId: true,
}

const LOTTE_SHOPPING = {
  useClientShippingId: true,
}

const ALI: ClientConfig = {
  useClientShippingId: true,
}

const W_SHOPPING: ClientConfig = {
  showReturningProducts: true,
}

const TAOBAO: ClientConfig = {
  useClientShippingId: true,
}

const WOOJIN: ClientConfig = {
  useClientShippingId: true,
}

export const CLIENT_CONFIGS: { [k: string]: ClientConfig } = {
  "120670196598": FMJ,
  "560868260125": FMJ,
  "100928880033": FMJ,
  "510777721850": FMJ,
  "164880727013": HANJIN,
  "558619842636": HANJIN,
  "195720472966": W_SHOPPING,
  "549217590275": W_SHOPPING,
  "107054273515": ALI,
  "107382026547": LOTTE_SHOPPING,
  "503231897649": LOTTE_SHOPPING,
  "110201815933": CJ,
  "525887971183": CJ,
  "593588772084": TAOBAO,
  "139710717700": TAOBAO,
  "155570418612": WOOJIN, // 우진 (prod)
  "544503821229": WOOJIN, // 우진 (field)
}

export const CLIENT_IDS = {
  ALI: ["107054273515"],
  CJ: ["110201815933", "525887971183"],
  LOTTE_SHOPPING: ["107382026547", "503231897649"],
}

export const CLIENTS_USING_STATION_CODE = [
  "124678982251", // 로드맨 B2C (prod)
  "597843884375", // 로드맨 B2C (non-prod)
  "100772038507", // 드림트리오 (prod)
  "537394564046", // 드림트리오 (non-prod)
  "196824672422", // 온브릭스 (prod)
]
